var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSaving),expression:"isSaving"}],staticClass:"save-text flash",style:(_vm.styleObj)},[_vm._v("Saving...")])
}
var staticRenderFns = []

export { render, staticRenderFns }